AvailabilitiesStore.dispatchToken = MakeShiftEmployeeDispatcher.register(
  AvailabilitiesStore.dispatchCallback,
);

AvailabilitiesStore.onAvailablesHandler = function (availablesData, response) {
  availablesData.reset(response.data.availabilities);
  AvailabilitiesStore.trigger('availables:load:success');
};

AvailabilitiesStore.onAvailablesError = function (error) {
  AvailabilitiesStore.trigger('availables:load:error', error);
};

AvailabilitiesStore.getAllAvailables = function () {
  const data = this.present();
  return data;
};

AvailabilitiesStore.getModelById = function (id) {
  const data = AvailabilitiesStore.get(id);
  return data;
};

AvailabilitiesStore.onAvailabilityCreated = function (model, response) {
  const exists = AvailabilitiesStore.get(response.data.availability.id);
  if (!exists) {
    AvailabilitiesStore.last().set({ id: response.data.availability.id });
    AvailabilitiesStore.trigger('availability:create:success', model.collection, response);
  }
};

AvailabilitiesStore.onAvailabilityCreatedError = function (collection, response) {
  AvailabilitiesStore.trigger('availability:create:error', response);
};

AvailabilitiesStore.onAvailabilityDeleted = function (model, response) {
  AvailabilitiesStore.trigger('availability:delete:success', model.present(), response);
};

AvailabilitiesStore.onAvailabilityDeletedError = function (collection, response) {
  AvailabilitiesStore.trigger('availability:delete:error', response);
};
